import { Fragment, type ReactNode } from 'react';

import { mergeClassNames } from '@/lib/utils';

export const DotSeparated = ({
  parts,
  className,
  dropWrappedDots = false,
}: {
  parts: ReactNode[];
  className?: string;
  // A part that wraps opens its line with no dot, rather than leaving one at
  // the end of the line above.
  dropWrappedDots?: boolean;
}) => {
  if (!parts.length) return null;
  // Each dot sits in its part's left padding, and the row is pulled left under
  // a clip, so the dot of whichever part starts a line is cut off.
  if (dropWrappedDots) {
    return (
      <span className="block overflow-hidden">
        <span
          className={mergeClassNames(
            '-ml-4 flex flex-wrap items-center text-sm text-gray-700',
            className
          )}
        >
          {parts.map((part, index) => (
            <span
              key={index}
              className="relative pl-4 before:absolute before:left-1.5 before:text-gray-400 before:content-['·']"
            >
              {part}
            </span>
          ))}
        </span>
      </span>
    );
  }
  return (
    <span
      className={mergeClassNames(
        'flex flex-wrap items-center gap-1.5 text-sm text-gray-700',
        className
      )}
    >
      {parts.map((part, index) => (
        <Fragment key={index}>
          {index > 0 && <span className="text-gray-400">·</span>}
          <span>{part}</span>
        </Fragment>
      ))}
    </span>
  );
};
